import { CheckboxField } from 'form';
import { SectionContainer, Typography } from 'ui';

export const ClearOverridesSection = () => {
  return (
    <SectionContainer columns={1} title={'Clear Load Overrides'}>
      <Typography>
        Some of the selected loads may have overrides for fields like &quot;carrier booking reference&quot;. If you want
        to clear those overrides, please select the &quot;Clear overrides on all the shipment&apos;s loads&quot;
        checkbox below. If you don&apos;t select it, some loads may have values that are different from their shipment.
      </Typography>
      <CheckboxField label="Clear overrides on all the shipment's loads" name="clear_loads_overrides" />
    </SectionContainer>
  );
};
